module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-d5de2abcaf3b6382ed4ba9bd2e99c338.svg";